/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import forEachObjIndexed from "ramda/src/forEachObjIndexed"
import { getLocaleInfo } from "./locale"

export const numberFormatter = (
  count: number,
  currencyCode: string,
): string => {
  const localeInfo = getLocaleInfo(currencyCode)
  const amountStr = count.toString()
  return amountStr.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    localeInfo.thousandSymbol,
  )
}

export const measureTextWidth = (
  pText: string,
  pFontSize: number,
): number => {
  const lDiv = document.createElement("div")
  document.body.appendChild(lDiv)
  lDiv.style.fontSize = `${pFontSize}px`
  lDiv.style.position = "absolute"
  lDiv.style.left = "-1000"
  lDiv.style.top = "-1000"
  lDiv.innerHTML = pText
  const width = lDiv.clientWidth
  document.body.removeChild(lDiv)
  return width
}

const dec2hex = (dec: number): string =>
  `0${dec.toString(16)}`.substr(-2)

export const randomString = (
  len: number = 32,
): string => {
  const arr = new Uint8Array((len || 40) / 2)
  window.crypto.getRandomValues(arr)
  return Array.from(arr, dec2hex).join("")
}

export const toTitleCase = (
  str: string,
): string => {
  if (str.length < 1) {
    return str
  }
  return str[0].toUpperCase() + str.slice(1)
}

export const replacePlaceholder = (
  replacer: { [idx: string]: string },
  target: string,
): string => {
  let ret = target
  forEachObjIndexed<{ [idx: string]: string }>(
    (value, key) => {
      ret = ret.replace(key.toString(), value)
    },
    replacer,
  )
  return ret
}

export function displayIfMatch<T>(
  conditions: Array<{ key: T; text: string }>,
  def?: string,
): (val: T) => string {
  return (val: T) => {
    let result = def || ""
    const normalizedVal =
      typeof val === "string" ? val.trim() : val
    for (
      let idx = 0;
      idx < conditions.length;
      idx += 1
    ) {
      const condition = conditions[idx]
      if (normalizedVal === condition.key) {
        result = condition.text
        break
      }
    }
    return result || `${val}`
  }
}
